import { SafariPwaModal1, SafariPwaModal2 } from '../assets/images';
import { useLocalStorageStore } from '../stores/localStorageStore';
import { MixpanelEvent, sendPostHogEvent } from '../utils/mixpanelUtil';

const SafariModal = ({ setShowSafariModal }) => {
  const handleSafariModalClose = () => {
    setShowSafariModal(false);
    const parsedData = useLocalStorageStore.getState().pwaInstallDeeplink || {};
    if (Object.keys(parsedData).length > 0) {
      MixpanelEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
          browser: 'safari',
        },
        true
      );
      sendPostHogEvent(
        'cta_clicked',
        {
          isVisible: false,
          ...parsedData,
          cta_context: 'pwa_install_banner',
          cta_page: window.location.pathname,
          cta_content: 'dismiss',
          browser: 'safari',
        },
        true
      );
    }
  };
  return (
    <div className='fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-50 px-4'>
      <div className='relative  w-full max-w-[26em] rounded-xl bg-cardBackground p-6'>
        <div className='space-y-6'>
          <h3 className='text-center text-lg font-medium text-text'>
            To install PadhAI on iOS
          </h3>
          <div className='flex items-start space-x-4'>
            <div className='flex-1'>
              <p className='mb-4 flex items-center text-text'>
                <span className='mr-2 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-border text-text'>
                  1
                </span>
                <span className='text-text'>Tap on Share button</span>
              </p>
              <div className='mt-2'>
                <img
                  src={SafariPwaModal1}
                  alt='Share button location'
                  className='w-full'
                />
              </div>
            </div>
          </div>
          <div className='flex items-start space-x-4'>
            <div className='flex-1'>
              <p className='mb-4 flex items-center text-text'>
                <span className='mr-2 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-border text-text'>
                  2
                </span>
                <span className='text-text'>
                  Scroll down and tap on 'Add to Home screen'
                </span>
              </p>
              <div className='mt-2'>
                <img
                  src={SafariPwaModal2}
                  alt='Share button location'
                  className='w-full'
                />
              </div>
            </div>
          </div>
          <button
            onClick={handleSafariModalClose}
            className='text-800 w-full rounded-full bg-border py-3 font-bold text-text'
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SafariModal;
